import { useTranslation } from "src/hooks";
import { ChainSingleSelection } from "src/components/ChainSelection";
import { FilterFieldsKeys } from "../../../../types/FilterFields";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";

interface IProps {
  value: string;
  onChange: (chainName: string) => void;
}

// currently will only support tron, not enable for selection
const ChainNameSingleSelection = (props: IProps) => {
  const { value, onChange } = props;
  const { translatePrefix } = usePageConfigProviderContext();

  const { t, tc } = useTranslation(translatePrefix);

  return (
    <ChainSingleSelection
      label={tc("phSelection", { fieldName: t(FilterFieldsKeys.ChainName) })}
      setChoice={onChange}
      choice={value}
    />
  );
};

export default ChainNameSingleSelection;
